import { css } from '@portal/styled-system/css'

import { useI18n } from '@/shared/lib/i18n'
import { CancelButton, Modal, type ModalProps, ProceedButton } from '@/shared/ui'

export type PasswordResetDialogProps = ModalProps & {
    email: string
    onClick: (params: { email: string }) => void
    nonInteractive?: boolean
}

export function PasswordResetDialog(props: PasswordResetDialogProps) {
    const { email, onClick, nonInteractive, ...modalProps } = props

    const { i18n } = useI18n()

    const handleResetClick = () => onClick({ email })

    return (
        <Modal {...modalProps}>
            <Modal.CloseButton onClose={modalProps.onClose} />
            <Modal.Header styles={css.raw({ backgroundColor: 'info', px: '5' })} icon="fa-solid fa-rocket-launch">
                {i18n.ACCOUNT_PASSWORD_RESET}
            </Modal.Header>
            <Modal.Body>
                <span dangerouslySetInnerHTML={{ __html: i18n.ACCOUNT_PASSWORD_SEND_LINK }} />
                <b>{email}</b>
            </Modal.Body>
            <Modal.Buttons>
                <CancelButton onPress={modalProps.onClose} styles={css.raw({ width: 'auto' })} />
                <ProceedButton onPress={handleResetClick} isDisabled={nonInteractive}>
                    {i18n.BUTTON_RESET_PASSWORD}
                </ProceedButton>
            </Modal.Buttons>
        </Modal>
    )
}
